import template from './leave_summary_help.html';
import * as Utils from '../../lib/savanna_utils.js';
import * as Permissions from '../../lib/permission_utils.js';

class LeaveSummaryHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveSummaryHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveSummaryHelpViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		Utils.refresh_data_visible_roles();
	}
};

// Register the dialog
export default {
	name: 'LeaveSummaryHelp',
	dialog_class: LeaveSummaryHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_summary_help',
	provider: 'ps'
};
